import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Svg from '_assets/svg';

const Button = styled.button`
    padding: 10px 15px;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    color: #26292D;
    border: 1px solid #BBC1C8;
    background: #F5F6F8;
    box-sizing: border-box;
    border-radius: 8px;
`

const Img = styled.img`
    width: 18.33px;
    height: 18.33px;
    margin-right: 10.42px;
    top: -1px;
    position: relative;
    
`
const TextInput = (props) => {
    const { className, id } = props;
    return (
        <>
            <Button className={`${className}`}>
                <Img src={Svg.attachment.default} />
                Upload photos
            </Button>
            <input
                type="file"
                id={id}
                aria-label="Upload"
                className="d-none"
            />
        </>
    );
}

TextInput.propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
};

TextInput.defaultProps = {
    className: ""
}

export default TextInput;